<template>
    <div class="compare">
    
        <label v-for="item in compare_vehicles"
            :class="compare2 === item.name ? 'active' : ''" >
            <input type="radio" @change="change"
            name="compare2"
            v-model="compare2" 
            :value="item.name"
            style="display:none"
             />
                    <div :id="'compare2'+item.name"></div>
        <h4>{{ item.label }}</h4>
         
        </label>
    
    </div>    
</template>

<script>

import RadioGroup from './RadioGroup.vue'
import SelectRange from './SelectRange.vue'
import Totals from '../mixins/Totals.js'
import Vehicles from '../mixins/Vehicles.js'

export default {
    mixins: [Totals, Vehicles],

    created() {
        for (var k in this.init_data){
            this.$data[k] = this.init_data[k];
        }
    },
    
    components: {
        RadioGroup, SelectRange
    },
    data: function(){
        return  {
            compare2 : ""
            
        }
    },
    props: {
        default : "",
    },
    computed: {
        compare_vehicles: function(){
            return [
                {
                    "name" : "bicycle",
                    "label" : this.$t('vehicles.bicycle')
                },{
                    "name" : "motorcycle",
                    "label" : this.$t('vehicles.motorcycle')
                },{
                    "name" : "car",
                    "label" : this.$t('vehicles.car')
                }
            ]
        }
    },
    methods: {
        select: function(which){
        
        }
    }
    

}
    

</script>

<style>

div.compare h4 {
    margin: .5em 0 0 0;
}

div.compare {
    margin: auto;
    smin-width: 500px;
    max-width: 900px;
    display: -webkit-flex;
    display: flex;
    text-align: center;
}


div.compare > label {
    margin: 1em;
    
}

div.compare > label > div:hover {
    border: 3px solid #222;
    cursor: pointer;
    background-color: #fff;
}

div.compare > label > div {
    border: 3px solid #fff;
    height: 100px;
    width: 100px;
    border-radius: 55px;
    margin: auto;
    background-position: 5px -12px;
    background-size: 90%;
    background-repeat: no-repeat;
    
}

div.compare > label.active > div {
    background-color: rgba(38,85,139,1);
    border: 3px solid #222;
}

div.compare > label > div#compare2car {
    background-image: url(../../public/icons/car_100.png);
}

div.compare > label > div#compare2motorcycle {
    background-image: url(../../public/icons/motorcycle_100.png);
}

div.compare > label > div#compare2bicycle {
    background-image: url(../../public/icons/bicycle_100.png);
}


div.compare > label.active > div#compare2car {
    background-image: url(../../public/icons/car_100_white.png);
}


div.compare > label.active > div#compare2motorcycle {
    background-image: url(../../public/icons/motorcycle_100_white.png);
}

div.compare > label.active > div#compare2bicycle {
    background-image: url(../../public/icons/bicycle_100_white.png);
}


</style>